module.exports = __webpack_public_path__ + "img/C2.351ee92f.png";